/**
 * Datum pokusu tak, jak ho kreslí návrh — „8. 7." bez roku.
 *
 * `now` je parametr, ne `new Date()` uvnitř: test tak nepotřebuje fake timers a chování
 * na přelomu roku jde ověřit přímo.
 *
 * AIDEV-NOTE: Rok u staršího pokusu je náš dodatek, návrh ho nemá — bez něj by loňská
 * a letošní zkouška vypadaly identicky. Ve specifikaci vedeno jako předpoklad. [TD-333]
 */
export const examHistoryDate = (iso: string, now: Date): string => {
  const date = new Date(iso);
  const withYear = date.getFullYear() !== now.getFullYear();

  return date.toLocaleDateString("cs-CZ", {
    day: "numeric",
    month: "numeric",
    ...(withYear ? { year: "numeric" } : {}),
  });
};
